import React from 'react';
import { string, func } from 'prop-types';
import {
  Select, Col
} from '@thd-olt-component-react/core-ui';
import classNames from 'classnames/bind';
import { MulchTooltip } from './MulchTooltip';
import styles from './mulch-options.module.scss';

const cx = classNames.bind(styles);

export const MulchOptions = ({
  size,
  mulch,
  handleBagSize,
  handleMulchType
}) => {
  let sizeOption = mulch;

  const mulchType = [
    {
      name: 'Wood',
      value: 'wood'
    },
    {
      name: 'Top Soil',
      value: 'top soil'
    },
    {
      name: 'Rubber',
      value: 'rubber'
    }
  ];

  const wood = [
    {
      name: '1.5 cu. ft. bags',
      value: '1.5',
    },
    {
      name: '2 cu. ft. bags',
      value: '2',
    }
  ];

  const topSoil = [
    {
      name: '0.75 cu. ft. bags',
      value: '0.75',
    },
    {
      name: '1 cu. ft. bags',
      value: '1',
    },
    {
      name: '1.5 cu. ft. bags',
      value: '1.5',
    }
  ];

  const rubber = [
    {
      name: '0.8 cu. ft. bags',
      value: '0.8',
    }
  ];

  if (mulch === 'wood') {
    sizeOption = wood;
  } else if (mulch === 'top soil') {
    sizeOption = topSoil;
  } else {
    sizeOption = rubber;
  }

  return (
    <>
      <div className={cx('calculator-options')}>
        <Col fallback={6} xs={6} sm={3} md={3} lg={3} nopadding>
          <div className={cx('calculator-options__input')}>
            <Select
              header="Type"
              selected={mulch}
              options={mulchType}
              onChange={(event) => { handleMulchType(event); }}
            />
          </div>
        </Col>
        <Col fallback={6} xs={6} sm={3} md={3} lg={3} nopadding>
          <div className={cx('calculator-options__input')}>
            <Select
              header="Bag Size"
              selected={size}
              options={sizeOption}
              onChange={(event) => { handleBagSize(event); }}
            />
          </div>
        </Col>
      </div>
      <MulchTooltip />
    </>
  );
};

MulchOptions.propTypes = {
  size: string,
  mulch: string,
  handleBagSize: func.isRequired,
  handleMulchType: func.isRequired
};

MulchOptions.defaultProps = {
  size: '1.5',
  mulch: 'wood'
};
